export default __webpack_public_path__ + "static/media/sectores_15.98cdf851.png";